module.exports = __webpack_public_path__ + "img/shop2_1.26c5ec4c.png";